import { image } from "../../components/assets/assets";
import AmpleHireImageTag from "../../components/ample-hire-html-tags/ample-hire-image-tag";
import { useGlobalContext } from "../../context";

const UserSignUpSignInImage = () => {

  const { rootColor } = useGlobalContext()

  return (
    <div className="col s12 xl6 l6 m6">
      <header className="logo-bg login-left-header">
        <AmpleHireImageTag
          imgSrc={rootColor?.logoUrl}
          altText={"brand-logo"}
        />
      </header>
      <figure className="ev-login-carector">
        <AmpleHireImageTag
          imgSrc={image.userSignupSigninPageImage}
          altText={"signin-page-image"}
        />
      </figure>
      <footer className="login-footer">
        <ul className="valign-wrapper">
          <li>Strategic Partner:</li>
          <li>
            <AmpleHireImageTag
              imgSrc={image.brandStrategicPartnerLogo}
              altText={"brand-logo"}
            />
          </li>
        </ul>
      </footer>
    </div>
  );
};

export default UserSignUpSignInImage;
